import { WorkerProfile } from 'src/DTO/WorkerProfile.type';
import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import {
  GetWorkersPayload,
  GetWorkersResponse,
  GetWorkerByIdPayload,
  GetWorkerContractsPayload,
  GetWorkerContractsResponse,
  GetWorkerDocumentsPayload,
  GetWorkerDocumentsResponse,
  InviteWorkerPayload,
  RemoveWorkerPayload,
  ResendWorkerInvitePayload,
  GetWorkerByIdResponse,
} from './useWorker.types';

export const useInviteWorkerRequest: BaseHookRequest<WorkerProfile, InviteWorkerPayload> =
  params => {
    const [{ postRequest }, state] = useApi<WorkerProfile>(params);
    const inviteWorker: BaseRequest<InviteWorkerPayload> = details => {
      postRequest<InviteWorkerPayload>('/manager/worker/invite/create', details?.variables);
    };

    return [inviteWorker, state];
  };

export const useGetAvailableWorkers: BaseHookRequest<GetWorkersResponse, GetWorkersPayload> =
  params => {
    const [{ postRequest }, state] = useApi<GetWorkersResponse>(params);
    const getWorkers: BaseRequest<GetWorkersPayload> = details => {
      postRequest<GetWorkersPayload>('/manager/worker/workers/available', details?.variables);
    };
    return [getWorkers, state];
  };

export const useGetInvitedWorkers: BaseHookRequest<GetWorkersResponse, GetWorkersPayload> =
  params => {
    const [{ postRequest }, state] = useApi<GetWorkersResponse>(params);
    const getWorkers: BaseRequest<GetWorkersPayload> = details => {
      postRequest<GetWorkersPayload>('/manager/worker/workers/invited', details?.variables);
    };
    return [getWorkers, state];
  };

export const useResendInviteRequest: BaseHookRequest<undefined, ResendWorkerInvitePayload> =
  params => {
    const [{ postRequest }, state] = useApi<undefined>(params);
    const resendWorkerInvite: BaseRequest<ResendWorkerInvitePayload> = details => {
      postRequest<ResendWorkerInvitePayload>('/manager/worker/invite/resend', details?.variables);
    };

    return [resendWorkerInvite, state];
  };

export const useRemoveWorkerRequest: BaseHookRequest<undefined, RemoveWorkerPayload> = params => {
  const [{ postRequest }, state] = useApi<undefined>(params);
  const removeWorker: BaseRequest<RemoveWorkerPayload> = details => {
    postRequest<RemoveWorkerPayload>('/manager/worker/remove', details?.variables);
  };

  return [removeWorker, state];
};

export const useGetWorkerDocuments: BaseHookRequest<
  GetWorkerDocumentsResponse,
  GetWorkerDocumentsPayload
> = params => {
  const [{ getRequest }, state] = useApi<GetWorkerDocumentsResponse>(params);
  const getWorkerDocuments: BaseRequest<GetWorkerDocumentsPayload> = details =>
    getRequest<GetWorkerDocumentsPayload>(`/manager/document/${details?.variables.id}/documents`);
  return [getWorkerDocuments, state];
};

export const useGetWorkerContracts: BaseHookRequest<
  GetWorkerContractsResponse,
  GetWorkerContractsPayload
> = params => {
  const [{ getRequest }, state] = useApi<GetWorkerContractsResponse>(params);
  const getWorkerContracts: BaseRequest<GetWorkerContractsPayload> = details =>
    getRequest<GetWorkerContractsPayload>(
      `/manager/document/workerContracts/${details?.variables.id}`,
    );
  return [getWorkerContracts, state];
};

export const useGetWorkerById: BaseHookRequest<GetWorkerByIdResponse, GetWorkerByIdPayload> =
  params => {
    const [{ getRequest }, state] = useApi<GetWorkerByIdResponse>(params);
    const getWorkerById: BaseRequest<GetWorkerByIdPayload> = details => {
      getRequest(`/manager/worker/details/${details?.variables.id}`);
    };
    return [getWorkerById, state];
  };
